// src/sw-cleanup.ts
export async function cleanupServiceWorkers() {
  try {
    if ('serviceWorker' in navigator) {
      const regs = await navigator.serviceWorker.getRegistrations();
      for (const r of regs) {
        try { await r.unregister(); } catch {}
      }
      // Reclama clientes en caso de que quede alguno vivo
      navigator.serviceWorker.getRegistrations?.();
    }
  } catch {}
}
